import { setter } from 'mobx-decorators'
import SMSConversationStore from 'stores/SMSConversationStore'
import callStore from 'stores/CallStore'
import ReminderStore from 'stores/ReminderStore'
import broadcastStore from 'stores/BroadcastStore'
import { notification, message } from 'antd'
import { raiseNotificationHost } from 'helpers/NotificationHost'
import { observable, autorun, reaction, action } from 'mobx'

export const SIDEBAR = {
  SMS: 'SMS',
  CALL: 'CALL',
  REMINDER: 'REMINDER',
  BROADCAST: 'BROADCAST'
}

export class UiStore {
  @observable
  selectedSidebar = null

  @setter
  @observable
  currentContact = null

  @setter
  @observable
  currentConversation = null

  @setter
  @observable
  showInbox = true

  @setter
  @observable
  shouldScrollToBottom = true

  @setter
  @observable
  showCallInfo = false

  @setter
  @observable
  showBroadcastInfo = false

  @setter
  @observable
  sidebarMaxHeight = false

  @setter
  @observable
  isStudentCardOpen = false

  @setter
  @observable
  isReportingInUse = false

  @setter
  @observable
  isLookerInUse = false

  @setter
  @observable
  isFeedbakInUse = false

  @setter
  @observable
  isConnectNavIframeCollapsed = false

  @setter
  @observable
  isCurrentSMSConversationActive = true

  @observable notifications = []

  @observable currentStudent = null

  constructor() {
    this.autoFetchSMSConversation()
    this.autoFetchCallLogs()
    this.autoHideCallInfo()
  }

  // Actions
  @action addNotification({ title, message, type }) {
    // Lift the host above any open <dialog>, or the notice renders behind its backdrop.
    raiseNotificationHost()

    notification[type]({
      message: title,
      description: message,
      style: getNotificationStyle(type)
    })
  }

  @action addMessage(msg, type = 'success') {
    if (!msg) return

    raiseNotificationHost()

    return message[type](msg)
  }

  @action setSidebarVisibility(show) {
    this.hideSidebar = !show
  }

  // Auto Actions
  @action autoFetchSMSConversation() {
    autorun('fetch conversation everytime it is updated', () => {
      if (!this.currentConversation) return

      this.shouldScrollToBottom = true
      SMSConversationStore.fetchConversation(this.currentConversation)
    })
  }

  @action handleCallSidebar() {
    callStore.fetchCallLogs()
  }

  @action autoFetchCallLogs() {
    reaction(
      () => this.showCallSidebar,
      (show) => show && callStore.fetchCallLogs()
    )
  }

  @action handleReminderSidebar() {
    ReminderStore.fetchReminders()
  }

  @action handleBroadcastSidebar() {
    broadcastStore.fetchBroadcasts()
  }

  @action autoHideCallInfo = () => {
    reaction(
      () => !this.hideSidebar || !this.showCallSidebar,
      (hide) =>
        hide && this.showCallInfo && (this.showCallInfo = false),
      true
    )
  }

  @action
  setSelectedSidebar = (sidebar) => {
    if (this.selectedSidebar === sidebar) {
      this.selectedSidebar = null
    } else {
      this.selectedSidebar = sidebar
    }
  }

  @action
  setCurrentStudent = (studentId) => {
    /*
     * Hide message sidebar when a user selects a new student while the student card is open
     */
    if (
      this.isStudentCardOpen &&
      this.currentStudent &&
      this.currentStudent !== studentId
    ) {
      this.setSelectedSidebar(null)
    }

    this.currentStudent = studentId
  }
}

function getNotificationStyle(type) {
  return {
    success: {
      color: 'rgba(0, 0, 0, 0.65)',
      border: '1px solid #b7eb8f',
      backgroundColor: '#f6ffed'
    },
    warning: {
      color: 'rgba(0, 0, 0, 0.65)',
      border: '1px solid #ffe58f',
      backgroundColor: '#fffbe6'
    },
    error: {
      color: 'rgba(0, 0, 0, 0.65)',
      border: '1px solid #ffa39e',
      backgroundColor: '#fff1f0'
    },
    info: {
      color: 'rgba(0, 0, 0, 0.65)',
      border: '1px solid #91d5ff',
      backgroundColor: '#e6f7ff'
    }
  }[type]
}

export default new UiStore()
